import { FormikErrors } from 'formik';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { validatePersonalDetails } from './steps/PersonalDetails/utils';

export const isRequired = (value: string | number | undefined): boolean => {
  if (!value) return true;

  if (typeof value === 'string' && value.trim() === '') return true;
  return false;
};

export const validateCVForm = (
  values: CVBuilderFormValues
): FormikErrors<CVBuilderFormValues> => {
  const errors: FormikErrors<CVBuilderFormValues> = {};

  // Validate language
  if (!values?.language || values.language.trim() === '') {
    errors.language = 'Language is required';
  }

  // Validate personal details
  const personalDetailsErrors = validatePersonalDetails(
    values.personalDetails || {}
  );

  if (Object.keys(personalDetailsErrors).length > 0) {
    errors.personalDetails = personalDetailsErrors;
  }

  return errors;
};
